module.exports = __webpack_public_path__ + "img/next-arrow.40033323.svg";